<div class="mx-auto">
  <% if notice.present? %>
    <p class="py-2 px-3 bg-green-50 mb-5 text-green-500 font-medium rounded-lg inline-block" id="notice"><%= notice %></p>
  <% end %>

  <div data-controller="info-box">
    <div class="info-button">&#x24D8;</div>
    <ul class="info-box">
      <li>Studios are the primary organizational unit for managing participants at your event.
      <li>Click on a studio name to view details and add people (Professionals, Guests, Students) to that studio.
      <li>The Count column shows the total number of people associated with each studio.
      <li>Use "New studio" to add a participating studio. Studios can be paired to enable cross-studio dancing.
    </ul>
  </div>

  <div class="flex justify-between items-center">
    <h1 class="mx-auto font-bold text-4xl pb-5">Studios</h1>
  </div>

  <div id="studios" class="min-w-full">
    <table class="table-fixed mx-auto">
    <thead>
      <tr>
        <td class="row-head">Location</td>
        <td class="row-head">Count</td>
      </tr>
    </thead>
    <tbody>
    <% @studios.each do |studio| %>
      <tr>
        <td class="text-black font-medium"><%= link_to studio.name, studio %></td>
        <td class="text-right"><%= studio.people.count %></td>
      </tr>
    <% end %>
      <tr>
        <th class="row-foot-right">totals</th>
        <td class="row-foot-right"><%= @total_count %></td>
      </tr>
    </tbody>
    </table>
  </div>

  <div class="mt-4 flex justify-between items-center">
    <%= link_to 'New studio', new_studio_path, class: "btn-blue" %>
    <div class="flex gap-2">
      <%= link_to "Back to Event", root_path, class: "btn-green" %>
    </div>
  </div>
</div>
